import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withKeys as _withKeys, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a43cc64e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modalCreate",
  tabindex: "-1",
  "aria-labelledby": "createPost",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title text-center fw-bold w-100",
  id: "staticBackdropLabel"
}
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "fw-bold col-form-label me-2" }
const _hoisted_12 = { class: "text-danger fs-7" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_15 = { class: "mb-2" }
const _hoisted_16 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "fw-bold col-form-label me-2" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode()
const _hoisted_20 = { class: "text-danger fs-7" }
const _hoisted_21 = { class: "position-relative mb-2" }
const _hoisted_22 = ["placeholder"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_26 = { class: "mb-0 fw-bold fs-7" }
const _hoisted_27 = { class: "fw-bold fs-7" }
const _hoisted_28 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_29 = {
  key: 1,
  class: "d-flex justify-content-center m-2"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 1,
  class: "me-2 text-truncate"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf me-2" }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 2,
  class: "invalid-error mar-bot-15"
}
const _hoisted_36 = {
  key: 1,
  class: "invalid-error mar-bot-15"
}
const _hoisted_37 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_38 = { class: "d-flex align-items-center" }
const _hoisted_39 = { class: "fw-bold col-form-label me-2" }
const _hoisted_40 = { class: "mt-2 d-flex align-items-center justify-content-between" }
const _hoisted_41 = { class: "d-flex align-items-center" }
const _hoisted_42 = { class: "fw-bold col-form-label me-2" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  key: 2,
  class: "invalid-error"
}
const _hoisted_45 = {
  key: 3,
  class: "invalid-error"
}
const _hoisted_46 = {
  key: 4,
  class: "invalid-feedback d-block"
}
const _hoisted_47 = {
  key: 5,
  class: "invalid-feedback d-block"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 fw-bold fs-7" }, " ※文字の入力を確定するとタグとして追加されます。 ", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 fw-bold fs-7" }, " ※タグは1つの投稿に5つまで設定できます。 ", -1))
const _hoisted_50 = { class: "modal-footer justify-content-center" }
const _hoisted_51 = {
  class: "modal fade",
  id: "modalBeforeCreate",
  tabindex: "-1",
  "aria-labelledby": "createPost",
  "aria-hidden": "true"
}
const _hoisted_52 = { class: "modal-dialog" }
const _hoisted_53 = { class: "modal-content" }
const _hoisted_54 = { class: "modal-header" }
const _hoisted_55 = {
  class: "modal-title text-center fw-bold w-100",
  id: "staticBackdropLabel"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_57 = { class: "modal-body p-3 pb-lg-5 w-100 mx-lg-auto mx-1" }
const _hoisted_58 = { class: "row mb-4 border-bottom-post" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold mar-bot-15" }, "投稿のタイプ", -1))
const _hoisted_60 = { class: "col-md-12" }
const _hoisted_61 = {
  key: 0,
  class: "break-word",
  style: {"width":"80%"}
}
const _hoisted_62 = { class: "row mb-4 border-bottom-post" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mar-bot-15 fw-bold" }, "タイトル", -1))
const _hoisted_64 = { class: "col-md-12" }
const _hoisted_65 = { class: "row mb-4 border-bottom-post" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mar-bot-15 fw-bold" }, "本文", -1))
const _hoisted_67 = { class: "col-md-12 break-spaces text-break" }
const _hoisted_68 = {
  key: 0,
  class: "row mb-4 border-bottom-post"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mar-bot-15 fw-bold" }, "添付ファイル", -1))
const _hoisted_70 = { class: "w-100 text-center" }
const _hoisted_71 = ["src"]
const _hoisted_72 = {
  key: 1,
  class: "row mb-4 border-bottom-post"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mar-bot-15 fw-bold" }, "添付ファイル", -1))
const _hoisted_74 = { class: "col-md-12 text-truncate" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf me-2" }, null, -1))
const _hoisted_76 = {
  key: 2,
  class: "row mb-4 border-bottom-post mt-n4 py-0 url-container"
}
const _hoisted_77 = { class: "row mb-4 border-bottom-post" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mar-bot-15 fw-bold" }, "タグ", -1))
const _hoisted_79 = { class: "d-flex flex-wrap" }
const _hoisted_80 = { class: "row" }
const _hoisted_81 = { class: "col-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_82 = { class: "col-6 d-flex justify-content-lg-start justify-content-center" }
const _hoisted_83 = {
  class: "modal fade",
  id: "modalCreateSuccess",
  tabindex: "-1",
  "aria-labelledby": "editPost",
  "aria-hidden": "true"
}
const _hoisted_84 = { class: "modal-dialog" }
const _hoisted_85 = { class: "modal-content" }
const _hoisted_86 = { class: "modal-header" }
const _hoisted_87 = { class: "modal-title text-center fw-bold w-100" }
const _hoisted_88 = {
  key: 0,
  class: "modal-body border-bottom-post-confirm mar-bot-15"
}
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "投稿しました。", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "confirmCreateText" }, [
  /*#__PURE__*/_createElementVNode("span", null, "画像などの添付ファイルはウィルスチェックに"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "時間がかかる場合があります。")
], -1))
const _hoisted_91 = [
  _hoisted_89,
  _hoisted_90
]
const _hoisted_92 = {
  key: 1,
  class: "modal-body border-bottom-post-confirm mar-bot-15"
}
const _hoisted_93 = { class: "text-center" }
const _hoisted_94 = {
  key: 2,
  class: "modal-body border-bottom-post-confirm mar-bot-15"
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "登録失敗しました。", -1))
const _hoisted_96 = [
  _hoisted_95
]
const _hoisted_97 = { class: "d-flex align-items-center justify-content-center pb-4" }

import HashTag from '@/components/hash-tag/index.vue'
import Button from '@/components/button/index.vue'
import ArticleGroup from '@/views/shared/communities/components/ArticleGroup.vue'
import { computed, ref, watch, onMounted, nextTick } from 'vue'
import { translate } from '@/languages/i18n'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import Status from '@/components/status/index.vue'
// import ModalBeforeCreate from '@/views/community-admin/group-list/components/ModalBeforeCreate.vue'

//validate
import useVuelidate from '@vuelidate/core'
import { required, minLength } from '@vuelidate/validators'
import { DEFAULT_MIN_LENGTH, MAX_UPLOAD_FILE_SIZE_MB, MAX_UPLOAD_FILE_SIZE_BYTES, MAX_LENGTH_POST_CONTENT } from '@/constants/number'

import { debounce, omit, pick, uniqBy, isEmpty } from 'lodash'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { USER_POST_STORE } from '@/store/constants'
import postService, { NewPost } from '@/services/post.services'
import { buildFormData, buildImgUrl, countCharInSurrogatePair, customMaxLength, customMinLength, handleBlurInput, scrollToErrors } from '@/utils'

import { imgTypes } from '@/constants/upload-type'
import { REGEX_EMOJI, validSimpleUrl } from '@/constants/regex'
import commonService from '@/services/common.service'
import { Modal } from 'bootstrap'
import { postMessageByCode } from '@/constants/messageCode.ts'
import UrlInput from '@/components/post-url/UrlInput.vue'
import { validateUrlRulesSF10, VALIDATOR_CONTAIN_NG_WORD } from '@/constants/validate'
import UrlDisplay from '@/components/post-url/UrlDisplay.vue'

type TAG = { id: number; name: string }


export default /*#__PURE__*/_defineComponent({
  props: {
  hasThreeTabs: Boolean,
},
  setup(__props) {



const modalConfirm = ref()
const modalFinish = ref()
const modalCreate = ref()

onMounted(() => {
  modalCreate.value = new Modal(document.getElementById('modalCreate'))
  modalConfirm.value = new Modal(document.getElementById('modalBeforeCreate'))
  modalFinish.value = new Modal(document.getElementById('modalCreateSuccess'))
})

const route = useRoute()

const inputRef = ref<HTMLElement | null>(null)

const uploadImgStatus = ref<boolean>(false)

const file = ref(null)
const fileData = ref(null)
const fileUrl = ref(null)
const fileName = ref<string>(null)
const fileType = ref<string>(null)
const errorUpload = ref(false)
const MaxUploadFileSize = ref(false)

/**
 * Combine with existed validation from v$ rules
 * update value after field blurred.
 */
const $externalResults = ref()

const MAX_LENGTH_TITLE = 30
const MAX_LENGTH_TEXT = MAX_LENGTH_POST_CONTENT

const tags = ref<Array<any>>([])

const tag = ref<Pick<TAG, 'title'>>('')

const content_type = ref<Pick<NewPost, 'content_type'>>(1)

const createFailed = ref<string>(null)

const store = useStore()

// 2022/09/21 CW-TrungNT Fix for UAT#4415: CT10 (Ph2-R20220922)
const postFailedMessageCode = ref(null)
const duplicateTags = ref<boolean>(false)

// const postDataToCreate = ref()

const setContentType = (contentType: number): void => {
  content_type.value = contentType
}

const checkTags = ref<boolean>(false)
const checkNgTags = async (): Promise<void> => {
  if (tags.value.length === 0) {
    checkTags.value = false
    emojiTag.value = false
    return
  }
  const tagData = tags.value.map((e: TAG) => e.name).join(', ')
  try {
    // REGEX_EMOJIは絵文字を含まない場合にTrueとなるので反転する
    emojiTag.value = !REGEX_EMOJI.test(tagData)
    if (!emojiTag.value) {
      const data = await commonService.sendNGWordCheck({ sentence: tagData })
      checkTags.value = data.data.data.has_ngword
    }
  } catch (error) {
    console.log(error)
  }
}

const createTag = async (): Promise<void> => {
  if (!tag.value || tags.value.length === 5) return
  isCheckedNGKeyTag.value = false
  await checkNGKeyTag(tag.value)
  while (!isCheckedNGKeyTag.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }
  if (emojiTag.value) return
  if (ngKeyTag.value) return
  const trimmedArray = tag.value.replace(/\s+/g, ' ').split(' ')
  trimmedArray.forEach((elem: string) => {
    for (let i = 0; i < elem.length; i = i + 20) {
      if (tags.value?.length === 5) break
      let trimmedString = elem.substring(i, i + 20)

      tags.value.push({
        id: `new-${Date.now()}${tags.value?.length}`,
        name: trimmedString,
      })
    }
  })

  tag.value = ''
  if (tags.value?.length < 5) {
    inputRef.value?.focus()
  }
}

const removeTag = async (id: number): Promise<void> => {
  tags.value = tags.value.filter((e: TAG) => e.id !== id)
  await checkNgTags()
}

const editTag = async (id: number, name: string): Promise<void> => {
  const trimmedArray = name.replace(/\s+/g, ' ').split(' ')
  trimmedArray.forEach((elem: string, index: number) => {
    for (let i = 0; i < elem.length; i = i + 20) {
      if ((index || (!index && i)) && tags.value?.length === 5) break
      let trimmedString = elem.substring(i, i + 20)

      if (!index && !i) {
        tags.value = tags.value.map((e: TAG) => ({
          ...e,
          name: e.id === id ? trimmedString : e.name,
        }))
      } else {
        tags.value.push({
          id: `new-${Date.now()}${tags.value?.length}`,
          name: trimmedString,
        })
      }
    }
  })
  await checkNgTags()
}

const rules = computed(() => {
  return {
    title: {
      required,
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_TITLE),
      minLength: minLength(DEFAULT_MIN_LENGTH),
    },
    content: {
      required,
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_TEXT),
      minLength: (value: string) => customMinLength(value, DEFAULT_MIN_LENGTH),
    },
    site_name_1: {},
    site_url_1: {},
    site_name_2: {},
    site_url_2: {},
    ...validateUrlRulesSF10('site_name_1', 'site_url_1', formData),
    ...validateUrlRulesSF10('site_name_2', 'site_url_2', formData),
  }
})

const formData = ref({
  title: '',
  content: '',
  file: '',
  site_name_1: '',
  site_url_1: '',
  site_name_2: '',
  site_url_2: '',
})

const textCounter = (maxLength: number, currentLength: number): number => {
  return maxLength - currentLength
}

const removeAvatar = (): void => {
  file.value = null
  fileData.value = null
  fileUrl.value = null
  fileName.value = null
  fileType.value = null
  formData.value.file = null
}

const handleChangeFile = async () => {
  uploadImgStatus.value = true
  if (file.value.files[0]) {
    const { newFileUrl, newFile } = await buildImgUrl(file.value.files[0])
    fileUrl.value = newFileUrl

    fileData.value = newFile

    fileType.value = newFile?.type
    fileName.value = newFile?.name
    formData.value.file = file.value.files[0]
  }
  uploadImgStatus.value = false
}

// 2022/09/30 PhucNV Fix bug can't register the same posted image as last time UAT#4571: CT10(Ph2-R20221007)
const handleFile = (event) => {
  event.target.value = null
}

const onInputURL = () => {
  v$.value.site_name_1.$touch()
  v$.value.site_url_1.$touch()
  v$.value.site_name_2.$touch()
  v$.value.site_url_2.$touch()
}

watch(
  () => fileType.value,
  () => {
    if (['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'].includes(fileType.value) || fileType.value === null) {
      if (formData.value?.content && formData.value.title) {
        v$.value.$invalid = false
      }
      errorUpload.value = false
    } else {
      v$.value.$invalid = true
      errorUpload.value = true
    }
  }
)

watch(
  () => formData.value?.file,
  () => {
    if (formData.value?.file && formData.value?.file.size > MAX_UPLOAD_FILE_SIZE_BYTES) {
      MaxUploadFileSize.value = true
    } else {
      MaxUploadFileSize.value = false
    }
  }
)

// 2022/09/21 CW-TrungNT Fix for UAT#4415: CT10 (Ph2-R20220922)
watch(
  () => tags.value,
  () => {
    if (uniqBy(tags.value, 'name').length !== tags.value.length) {
      duplicateTags.value = true
    } else {
      duplicateTags.value = false
    }
  },
  { immediate: true, deep: true }
)

const v$ = useVuelidate(rules, formData, { $externalResults })

const onSubmit = async () => {
  v$.value.$touch()

  isCheckedNGKeyTitle.value = false
  isCheckedNGKeyContent.value = false

  await checkNGKeyTitle()
  await checkNGKeyContent()

  if (formData.value.site_name_1) await validateUrlNgWord('site_name_1')
  if (formData.value.site_name_2) await validateUrlNgWord('site_name_2')

  while (!isCheckedNGKeyTitle.value || !isCheckedNGKeyContent.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (
    v$.value.$invalid ||
    ngKeyTitle.value ||
    ngKeyContent.value ||
    checkTags.value ||
    emojiTag.value ||
    ngKeyTag.value ||
    MaxUploadFileSize.value ||
    errorUpload.value ||
    duplicateTags.value
  ) {
    nextTick(() => {
      const elementErrors = document.querySelector('#modalCreate .invalid-feedback')
      const classErrors = elementErrors ? '.invalid-feedback' : '.invalid-error'
      scrollToErrors(classErrors, '#modalCreate')
    })
    return
  }
  modalCreate.value?.hide()
  modalConfirm.value?.show()
}
const loadingCreate = ref<boolean>(false)

const createPost = async () => {
  const newPostJson = {
    ...omit(formData.value, 'file'),
    content_type: content_type.value,
    tags: tags.value.map((e: TAG) => pick(e, 'name')),
    create_by_admin: true,
  }
  loadingCreate.value = true

  const newPost = new FormData()
  buildFormData(newPost, newPostJson)

  if (fileData.value) {
    newPost.append(imgTypes.includes(fileType.value) ? 'image' : 'file', fileData.value)
  }
  const queryData = {
    chatroom_id: route.params.id,
    params: { ...route.query, page_of_number: route.query?.page_of_number || 30 },
    operational_posts: route.path.includes('operational_posts'),
  }

  try {
    const data = await postService.createPost(newPost, route.params.id)
    if (data.status === 200) {
      createFailed.value = '200'
    } else {
      const messageCode = data?.response?.data?.data[0]?.message_code
      if (messageCode) postFailedMessageCode.value = messageCode
      createFailed.value = 'error-400'
    }
    if (data.data?.success) {
      if (queryData.operational_posts) {
        store.dispatch(USER_POST_STORE.ACTIONS.GET_OPERATIONAL_POST, omit(queryData, 'operational_posts'))
      } else {
        store.dispatch(USER_POST_STORE.ACTIONS.GET_POST, omit(queryData, 'operational_posts'))
      }
    }
    loadingCreate.value = false
    modalConfirm.value?.hide()
    modalFinish.value?.show()
  } catch (error) {
    createFailed.value = 'other'
  }
  //store.dispatch(USER_POST_STORE.ACTIONS.CREATE_POST, { newPost: newPost, community_id: route.params.id, queryData })

  resetData()
}

const textTitle = (valueTitle: number): string => {
  if (valueTitle === 1) return '記事'
  if (valueTitle === 2) return '募集'
  if (valueTitle === 3) return '求人'
}

const resetData = (): void => {
  v$.value.$reset()
  formData.value = {
    title: '',
    content: '',
    site_name_1: '',
    site_url_1: '',
    site_name_2: '',
    site_url_2: '',
  }
  tags.value = []
  file.value = null
  fileUrl.value = null
  fileName.value = null
  fileType.value = null
  tag.value = null
  content_type.value = 1
  ngKeyTitle.value = false
  ngKeyContent.value = false
  emojiTag.value = false
  ngKeyTag.value = false
  checkTags.value = false
  fileData.value = ''
}

const isCheckedNGKeyTitle = { value: false }
const ngKeyTitle = ref<boolean>(false)
const checkNGKeyTitle = debounce(async () => {
  const queryData = { sentence: v$.value.title.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngKeyTitle.value = data.data.data.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyTitle.value = true
  }
})

const isCheckedNGKeyContent = { value: false }
const ngKeyContent = ref<boolean>(false)
const checkNGKeyContent = debounce(async () => {
  const queryData = { sentence: v$.value?.content.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngKeyContent.value = data.data.data.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyContent.value = true
  }
})

const isCheckedNGKeyTag = { value: false }
const emojiTag = ref<boolean>(false)
const ngKeyTag = ref<boolean>(false)
const checkNGKeyTag = debounce(async (value: string) => {
  if (!value || tags.value.length === 5) {
    emojiTag.value = false
    ngKeyTag.value = false
    isCheckedNGKeyTag.value = true
    return
  }
  const queryData = { sentence: value }
  try {
    // REGEX_EMOJIは絵文字を含まない場合にTrueとなるので反転する
    emojiTag.value = !REGEX_EMOJI.test(value)
    if (!emojiTag.value) {
      const data = await commonService.sendNGWordCheck(queryData)
      ngKeyTag.value = data.data.data.has_ngword
    } else {
      ngKeyTag.value = false
    }
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyTag.value = true
  }
})

watch(
  () => tag.value,
  (newVal: any) => {
    checkNGKeyTag(newVal as string)
  }
)

const focusInputTag = () => {
  if (tags.value.length === 5) return

  inputRef.value?.focus()
}

const validateUrlNgWord = async (name: string) => {
  const queryData = { sentence: formData.value[name] }
  const data = await commonService.sendNGWordCheck(queryData)
  const { has_ngword: isNotValid } = data.data.data

  $externalResults.value = { ...$externalResults.value, [name]: isNotValid ? [VALIDATOR_CONTAIN_NG_WORD] : [] }
}

const showUrlInConfirmDialog = () =>
  !isEmpty(formData.value.site_name_1) || !isEmpty(formData.value.site_url_1) || !isEmpty(formData.value.site_name_2) || !isEmpty(formData.value.site_url_2)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Button, {
      title: _unref(translate)('createNewPost'),
      "data-bs-Toggle": "modal",
      "data-bs-target": "#modalCreate",
      type: 'secondary',
      onClick: resetData
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('userCreatePost')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: resetData
            })
          ]),
          _createElementVNode("form", {
            onSubmit: _withModifiers(onSubmit, ["prevent"]),
            class: "w-100 mx-lg-auto mx-1"
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(ArticleGroup, {
                hasThreeTabs: __props.hasThreeTabs,
                onSetContentType: setContentType,
                content_type: content_type.value
              }, null, 8, ["hasThreeTabs", "content_type"]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(translate)(`title`)), 1),
                    _createVNode(Status)
                  ]),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(textCounter(MAX_LENGTH_TITLE, _unref(countCharInSurrogatePair)(formData.value.title))), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "title",
                  class: _normalizeClass(['form-control mb-2', ngKeyTitle.value || _unref(v$).title.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).title.$model) = $event)),
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNGKeyTitle) && _unref(checkNGKeyTitle)(...args))),
                  placeholder: _unref(translate)('SD10requireTitle')
                }, null, 42, _hoisted_13), [
                  [
                    _vModelText,
                    _unref(v$).title.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (ngKeyTitle.value && !_unref(v$).title.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputErrorMessage, {
                  title: 'title',
                  validator: _unref(v$).title.$errors[0]?.$validator,
                  params: [_unref(DEFAULT_MIN_LENGTH), MAX_LENGTH_TITLE]
                }, null, 8, ["validator", "params"]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(translate)(`content`)), 1),
                      _hoisted_19,
                      _createVNode(Status)
                    ]),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(textCounter(_unref(MAX_LENGTH_TEXT), _unref(countCharInSurrogatePair)(formData.value?.content))), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _withDirectives(_createElementVNode("textarea", {
                      name: "content",
                      rows: "5",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).content.$model) = $event)),
                      onBlur: _cache[3] || (_cache[3] = () => (_unref(v$).content.$model = _unref(v$).content.$model.replace(/\n+$/, ''))),
                      onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(checkNGKeyContent) && _unref(checkNGKeyContent)(...args))),
                      class: _normalizeClass(['form-control ', ngKeyContent.value || _unref(v$).content.$error ? 'is-invalid' : '']),
                      placeholder: _unref(translate)('SD10requireText')
                    }, null, 42, _hoisted_22), [
                      [_vModelText, _unref(v$).content.$model]
                    ]),
                    _createElementVNode("label", {
                      class: _normalizeClass(['camera position-absolute cursor-pointer', ngKeyContent.value || _unref(v$).content.$error ? 'camera--err' : '']),
                      for: "img"
                    }, _hoisted_24, 2),
                    _createElementVNode("input", {
                      type: "file",
                      class: "d-none",
                      id: "img",
                      ref: (_value, _refs) => {
                        _refs['file'] = _value
                        file.value = _value
                      },
                      onChange: handleChangeFile,
                      onClick: handleFile,
                      accept: "image/png, image/jpeg, image/jpg, application/pdf"
                    }, null, 544),
                    (ngKeyContent.value && !_unref(v$).content.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                      : _createCommentVNode("", true),
                    _createVNode(InputErrorMessage, {
                      title: 'content',
                      validator: _unref(v$).content.$errors[0]?.$validator,
                      params: [_unref(DEFAULT_MIN_LENGTH), _unref(MAX_LENGTH_TEXT)]
                    }, null, 8, ["validator", "params"])
                  ]),
                  _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(translate)('postImageAnnotation1')), 1),
                  _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(translate)('postImageAnnotation2')), 1),
                  (uploadImgStatus.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                    : _createCommentVNode("", true),
                  (fileName.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        (fileType.value.includes('image'))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: fileUrl.value,
                              alt: "image",
                              class: "me-2 object-fit-contain mw-100"
                            }, null, 8, _hoisted_30))
                          : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              _hoisted_32,
                              _createTextVNode(_toDisplayString(fileName.value), 1)
                            ])),
                        _createElementVNode("div", {
                          class: "close-icon cursor-pointer",
                          onClick: removeAvatar
                        }, _hoisted_34)
                      ]))
                    : _createCommentVNode("", true),
                  (MaxUploadFileSize.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_unref(translate)('validateFileSize', '', [_unref(MAX_UPLOAD_FILE_SIZE_MB)])), 1))
                    : _createCommentVNode("", true)
                ]),
                (errorUpload.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_unref(translate)('errorFileUpload')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("label", _hoisted_39, _toDisplayString(_unref(translate)(`CT10url`)), 1)
                  ])
                ]),
                _createVNode(UrlInput, {
                  onInput: onInputURL,
                  "site-name-id": "site_name_1",
                  "site-url-id": "site_url_1",
                  "on-field-blur": validateUrlNgWord,
                  "site-url": _unref(v$).site_url_1,
                  "site-name": _unref(v$).site_name_1,
                  "site-name-label": _unref(translate)('CT10siteName1'),
                  "site-url-label": _unref(translate)('CT10siteUrl1')
                }, null, 8, ["site-url", "site-name", "site-name-label", "site-url-label"]),
                _createVNode(UrlInput, {
                  onInput: onInputURL,
                  class: "mt-4",
                  "site-name-id": "site_name_2",
                  "site-url-id": "site_url_2",
                  "on-field-blur": validateUrlNgWord,
                  "site-url": _unref(v$).site_url_2,
                  "site-name": _unref(v$).site_name_2,
                  "site-name-label": _unref(translate)('CT10siteName2'),
                  "site-url-label": _unref(translate)('CT10siteUrl2')
                }, null, 8, ["site-url", "site-name", "site-name-label", "site-url-label"]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("label", _hoisted_42, _toDisplayString(_unref(translate)(`CT10tag`)), 1)
                  ])
                ]),
                _createElementVNode("label", {
                  class: "d-flex flex-wrap form-control mb-2",
                  onClick: _withModifiers(focusInputTag, ["self"])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
                    return (_openBlock(), _createBlock(HashTag, {
                      tag: tag,
                      key: tag.id,
                      class: "me-2 mb-2",
                      removeTag: () => removeTag(tag.id),
                      onEditTag: editTag,
                      editable: true
                    }, null, 8, ["tag", "removeTag"]))
                  }), 128)),
                  (tags.value.length < 5)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        ref: (_value, _refs) => {
                          _refs['inputRef'] = _value
                          inputRef.value = _value
                        },
                        type: "text",
                        class: "border-0 input-tag",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((tag).value = $event)),
                        onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => ($event.target.blur()), ["enter"])),
                        onInput: _cache[7] || (_cache[7] = (eve) => _unref(handleBlurInput)(eve, inputRef.value)),
                        onBlur: createTag
                      }, null, 544)), [
                        [
                          _vModelText,
                          tag.value,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    : _createCommentVNode("", true)
                ], 8, _hoisted_43),
                (emojiTag.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_unref(translate)('validateEmoji')), 1))
                  : (ngKeyTag.value || checkTags.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                    : (duplicateTags.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_unref(translate)('VALIDATE_SAME_TAGS')), 1))
                      : _createCommentVNode("", true),
                (tags.value.length > 5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, " ※タグは1つの投稿に5つまで設定できます。 "))
                  : _createCommentVNode("", true),
                _hoisted_48,
                _hoisted_49
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createVNode(Button, {
                title: _unref(translate)('cancel'),
                class: "m-w-unset",
                type: 'secondary',
                "data-bs-dismiss": "modal",
                onClick: resetData
              }, null, 8, ["title"]),
              _createVNode(Button, {
                onClick: onSubmit,
                title: _unref(translate)('confirm'),
                class: "m-w-unset",
                type: 'secondary',
                disabled: _unref(v$).$invalid || errorUpload.value || emojiTag.value || ngKeyTag.value || checkTags.value || duplicateTags.value
              }, null, 8, ["title", "disabled"])
            ])
          ], 40, _hoisted_6)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("h5", _hoisted_55, _toDisplayString(_unref(translate)('userCreatePost')), 1),
            _hoisted_56
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _hoisted_59,
              _createElementVNode("div", _hoisted_60, _toDisplayString(textTitle(content_type.value)), 1),
              (content_type.value === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_unref(translate)('postJob')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_62, [
              _hoisted_63,
              _createElementVNode("div", _hoisted_64, _toDisplayString(formData.value.title), 1)
            ]),
            _createElementVNode("div", _hoisted_65, [
              _hoisted_66,
              _createElementVNode("div", _hoisted_67, _toDisplayString(formData.value?.content), 1)
            ]),
            (fileUrl.value && ['image/jpeg', 'image/jpg', 'image/png'].includes(fileType.value))
              ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                  _hoisted_69,
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("img", {
                      src: fileUrl.value,
                      alt: "image",
                      class: "file-url mh-100"
                    }, null, 8, _hoisted_71)
                  ])
                ]))
              : _createCommentVNode("", true),
            (fileUrl.value && fileType.value === 'application/pdf')
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  _hoisted_73,
                  _createElementVNode("div", _hoisted_74, [
                    _hoisted_75,
                    _createTextVNode(" " + _toDisplayString(fileName.value), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (showUrlInConfirmDialog())
              ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                  _createVNode(UrlDisplay, {
                    "site-url": formData.value.site_url_1,
                    "site-name": formData.value.site_name_1
                  }, null, 8, ["site-url", "site-name"]),
                  _createVNode(UrlDisplay, {
                    "site-url": formData.value.site_url_2,
                    "site-name": formData.value.site_name_2
                  }, null, 8, ["site-url", "site-name"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_77, [
              _hoisted_78,
              _createElementVNode("div", _hoisted_79, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "text-break me-2 mb-2",
                    key: tag.id
                  }, _toDisplayString('#' + tag.name), 1))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _createVNode(Button, {
                  title: _unref(translate)('postEdit'),
                  class: "m-w-unset",
                  type: 'secondary',
                  dataBsToggle: 'modal',
                  dataBsTarget: '#modalCreate'
                }, null, 8, ["title"])
              ]),
              _createElementVNode("div", _hoisted_82, [
                _createVNode(Button, {
                  onClick: createPost,
                  title: _unref(translate)('postSubmit'),
                  class: "m-w-unset",
                  type: 'secondary',
                  loading: loadingCreate.value,
                  disabled: loadingCreate.value
                }, null, 8, ["title", "loading", "disabled"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_83, [
      _createElementVNode("div", _hoisted_84, [
        _createElementVNode("div", _hoisted_85, [
          _createElementVNode("div", _hoisted_86, [
            _createElementVNode("h5", _hoisted_87, _toDisplayString(_unref(translate)('userCreatePost')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
            })
          ]),
          (createFailed.value === '200')
            ? (_openBlock(), _createElementBlock("div", _hoisted_88, _hoisted_91))
            : (createFailed.value === 'error-400')
              ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                  _createElementVNode("p", _hoisted_93, _toDisplayString(_unref(postMessageByCode)(postFailedMessageCode.value) || '投稿の登録に失敗しました。'), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_94, _hoisted_96)),
          _createElementVNode("div", _hoisted_97, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              class: "m-w-unset",
              type: 'secondary',
              "data-bs-dismiss": "modal"
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})